const carousels = document.querySelectorAll('.carousel__items');

carousels.forEach(carousel => {
    const swiper = new Swiper(carousel, {
        slidesPerView: 'auto',
        loop: true,
        spaceBetween: parseInt(carousel.dataset.gap) || 0,
        pagination: {
            el: carousel.querySelector('.swiper-pagination'),
            clickable: true,
        },
        navigation: {
            nextEl: carousel.querySelector('.carousel__btn-next'),
            prevEl: carousel.querySelector('.carousel__btn-prev'),
        },
    });
});